<template>
  <div class="CodeMirror">
    <textarea
      v-model="code"
      :options="editorOptions"
      style="margin-left: 100px;height: 300px;width: 300px;"
    ></textarea>
    <button @click="runCode">运行</button>
    <pre>{{ output }}</pre>
  </div>
</template>

<script>
import Sk from "skulpt";

export default {
  data() {
    return {
      code: "",
      editorOptions: {
        mode: "python",
        theme: "default",
        lineNumbers: true
      },
      output: ""
    };
  },
  methods: {
    runCode() {
      Sk.configure({
        output: text => {
          this.output += text;
        },
        read: x => {
          if (
            Sk.builtinFiles === undefined ||
            Sk.builtinFiles["files"][x] === undefined
          )
            throw new Error(`File not found: '${x}'`);
          return Sk.builtinFiles["files"][x];
        }
      });
      Sk.misceval
        .asyncToPromise(() => {
          return Sk.importMainWithBody("<stdin>", false, this.code, true);
        })
        .catch(err => {
          this.output += err.toString();
        });
    }
  }
};
</script>

<style>
/* CodeMirror编辑器的样式 */
.CodeMirror {
  height: 800px;
}
</style>



// WEBPACK FOOTER //
// src/components/comtest.vue